import { render, staticRenderFns } from "./RelatedPositions.vue?vue&type=template&id=068c9f14"
import script from "./RelatedPositions.vue?vue&type=script&lang=js"
export * from "./RelatedPositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports